import React, { useEffect } from 'react';
import { Box, Grid } from '@mui/material';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

// Components
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Sidebar from '../../components/Sidebar/Sidebar';
import InitialChoice from './InitialChoice';

// Styles
import '../../scss/Form.scss';

const SignUp: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Navigation handlers - simple and clean
  const handlePersonalChoice = () => {
    navigate('/signup-individual');
  };

  const handleSchoolChoice = () => {
    navigate('/signup-school-select');
  };

  return (
    <>
      <Helmet>
        <title>Sign Up to Learn & Play Spelling Games For Kids - Spelling Hero</title>
        <meta name="description" content="Join Spelling Hero today! Create your account to access engaging spelling games and educational content for kids. Sign up for personal use or set up your school." />
        <meta name="keywords" content="spelling games, kids education, sign up, create account, school registration" />
        <meta name="robots" content="index, follow" />
        
        {/* Open Graph tags */}
        <meta property="og:title" content="Sign Up to Learn & Play Spelling Games For Kids - Spelling Hero" />
        <meta property="og:description" content="Join Spelling Hero today! Create your account to access engaging spelling games and educational content for kids. Sign up for personal use or set up your school." />
        <meta property="og:type" content="website" />
        
        {/* Canonical URL */}
        <link rel="canonical" href={`${window.location.origin}/signup`} />
      </Helmet>

      <header>
        <Navbar currentPage="signup" />
      </header>

      <main className="main-container" style={{ paddingTop: 0 }}>
        <section className="quiz-signup">
          <Box sx={{ padding: 0 }}>
            <Grid container spacing={2}>
              {/* Sidebar */}
              <Grid
                item
                lg={5}
                xs={12}
                sm={12}
                sx={{ paddingLeft: 0 }}
                className="sidebar-top-spacing"
              >
                <Sidebar />
              </Grid>

              {/* Main Content */}
              <Grid item xs={12} sm={12} lg={7} xl={7}>
                <Box sx={{
                  position: 'relative',
                  paddingLeft: { xs: 2, sm: 3, md: 4 },
                  paddingRight: { xs: 2, sm: 3, md: 4 },
                  paddingTop: 2,
                  paddingBottom: 4,
                  marginTop: { xs: 2, md: 4 }
                }}>
                  {/* Center the InitialChoice component vertically like Login */}
                  <Box sx={{ display: 'flex', alignItems: 'center', minHeight: '100%' }}>
                    <InitialChoice 
                      onPersonalClick={handlePersonalChoice}
                      onSchoolClick={handleSchoolChoice}
                    />
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default SignUp;
